export default __webpack_public_path__ + "static/boomwriter-d2dd23d07c48881a4e851d1f606b753d.png";